/* eslint-disable import/prefer-default-export */
function upperCaseToCamelWithSpaces(str) {
  /* Transforms ADD_TWO_NUMBERS to Add Two Numbers */
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
export { upperCaseToCamelWithSpaces };
